export const APIDisplayOverrides = {
  // the 'hideApi' array contains the names of the API's to not show. The name needs to match
  // the keys as defined in the 'paths' object in 3dx_api.json
  // For example: "hideApi": ["/GetSystemTranslations", "/Analytics", "/GetProductDrawings"]
  "hideApi": [],

  // the 'hideApiParameter' array is a list of objects which hide specific parameters of specific API's
  // each object contains 2 keys:
  // 'apiName' - the name of the API that contains the specified parameters to hide. The name needs to match
  //             the keys as defined in the 'paths' object in 3dx_api.json
  // 'parameterNamesToHide' - an array of parameter names to hide in the UI for this API. The names must match
  //                             the 'name' key of the parameters as defined in the objects of the 'parameters' array
  //                             in 3dx_api.json
  //Example:
//    "hideApiParameter": [
//    {
//      "apiName": "/SearchAllCatalogs",
//      "parameterNamesToHide": ["includeDoesCadExist","includeTotal"]
//    },
//    {
//      "apiName": "/GetProductPreview",
//      "parameterNamesToHide": ["urlOnly"]
//    },
//    {
//      "apiName": "/AnalyticsNumbers",
//      "parameterNamesToHide": ["dateEnd"]
//    }
//  ]

  "hideApiParameter": [
    {
      "apiName": "/SearchAllCatalogs",
      // for now, hide the 'includeDoesCadExist' parameter of the SearchAllCatalogs API. The addition of that parameter
      // in a true state adds a lot of overhead to our system...
      "parameterNamesToHide": ["includeDoesCadExist"]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/constants/CustomSettings.js